import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AlertController, NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { filter, Subject, takeUntil } from 'rxjs';

import { rateOurAnswer } from '../../../../../app/store/actions';
import { AppState } from '../../../../../app/store/app-reducers';
import { RateOurAnswerState } from '../../../../store/reducers/content-management.reducer';
import { SharedAnalyticsService } from '../../../../shared/analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsPageViews } from '../../../../shared/enums/analytics.enum';
import { GTMEventsCrash } from '../../../../shared/enums/Crashlytics';
import { EventInteraction, GTMInteractions, NativeStorageNamesV2, SECTIONS } from '../../../../shared/models/Constants';
import { respuestapregunta } from '../../../../shared/models/respuesta';
import { AnalyticsService } from '../../../../shared/services/analytics.service';
import { CrashlyticsService } from '../../../../shared/services/crashlytics/crashlytics.service';
import { StorageData } from '../../../../shared/services/utilities/storage-data.class';
import { Preguntas } from '../../models/preguntas';

@Component({
  selector: 'preguntas',
  templateUrl: './preguntas.component.html',
  styleUrls: ['./preguntas.component.scss'],
})

export class PreguntasComponent implements OnInit, OnDestroy {

  @Input() preguntas: Preguntas[] = []

  @Output() valueEmit = new EventEmitter<object>()
  @Output() submit = new EventEmitter<object>()

  public isEnabled = false
  public spinner = false
  public icono = './assets/icon/rate-icon-gray.svg'
  public respuestasList: respuestapregunta[] = []

  private destroy$ = new Subject<void>();
  private alert: any = null

  constructor(
    public alertController: AlertController,
    private nav: NavController,
    private analyticsService: AnalyticsService,
    private sharedAnalyticsS: SharedAnalyticsService,
    private crashlytics: CrashlyticsService,
    private translate: TranslateService,
    private store: Store<AppState>
  ) { }

  ngOnInit() {
    this.store.select('rateOurAnswer')
      .pipe(
        filter(state => this.spinner && !state.loading && (state.success || state.failed)),
        takeUntil(this.destroy$)
      )
      .subscribe(state => {
        this.spinner = false;
        if (state.success) {
          this.handleAnswerSuccess(state.data);
        } else if (state.failed) {
          this.handleAnswerFailure(state.error);
        }
      });
  }

  private handleAnswerSuccess(data: RateOurAnswerState['data']): void {
    if (data?.[0]?.Mensaje !== 'DATOS INGRESADOS CORRECTAMENTE!') {
      return;
    }

    this.presentAlert(
      this.translate.instant('Labels.very-good'),
      this.translate.instant('Labels.thanks-for-your-participation'),
      this.translate.instant('Labels.answers-received-correctly')
    );
    StorageData.getDataStorage(NativeStorageNamesV2.PerfilUsuario)
      .then(userData => {
        if (userData) {
          this.sharedAnalyticsS.trackPageView(EAnalyticsPageViews.rateUsThanksView, SECTIONS.CALIFICA);
        }
      });
  }

  private handleAnswerFailure(error: RateOurAnswerState['error']): void {
    this.presentAlert(
      this.translate.instant('Labels.oh-oh'),
      this.translate.instant('Labels.try-again-later'),
      this.translate.instant('Labels.check-your-internet-connection')
    );
    this.crashlytics.sendCrashPlatform(GTMEventsCrash.sendRespuestaCalificanosApi, error);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.alert !== null) {
      this.alert.dismiss()
    }
  }

  cambioPregunta(event: respuestapregunta) {
    this.isEnabled = true
    this.meterPregunta(event)
  }

  meterPregunta(respuesta: respuestapregunta) {
    const existente = this.respuestasList.find(x => x.ID_CalificaPregunta === respuesta.ID_CalificaPregunta);
    existente ? Object.assign(existente, respuesta) : this.respuestasList.push(respuesta);
  }

  async presentAlert(titulo, subtitulo, mensaje) {
    if (this.alert !== null) {
      this.alert.dismiss()
    }
    this.alert = await this.alertController.create({
      header: titulo,
      subHeader: subtitulo,
      message: mensaje,
      buttons: [
        {
          text: this.translate.instant('Buttons.accept'),
          role: 'cancel',
          handler: () => {
            this.analyticsService.sendEventAnalytics(GTMInteractions.acceptThanksRateUsEvent, EventInteraction)
          },
        },
      ],

      backdropDismiss: false,
      mode: 'md',
      cssClass: 'ion-alert-calificanos'
    })

    await this.alert.present()
    await this.alert.onDidDismiss()
    this.nav.back({ animated: true, animationDirection: 'back' });
  }

  public mandarDatos = () => {
    this.store.dispatch(rateOurAnswer({ Respuestas: JSON.stringify(this.respuestasList) }));
    this.spinner = true
    this.analyticsService.sendEventAnalytics(GTMInteractions.sendRateUsEvent, EventInteraction);
    this.isEnabled = false
  }

}
